import { BottomNavigation } from './BottomNavigation';
import { TopNavigation } from './TopNavigation';

export { TopNavigation, BottomNavigation };
